import { Component, ViewChild, AfterViewInit, ViewEncapsulation, Input } from '@angular/core';
import { ConstantsService } from '../../services/constantsService';
import { ContextService } from '../../services/contextService';
import { AppSpinner } from '../../custom-elements/app-spinner/component';
import { Registration } from './registration/registration'
// import { AdmissionPageComponent } from './admission-page/admission-page';
import { FormField } from '../../services/formService';
import { Validations, Validators } from '../../services/validations';
import { HttpService } from '../../services/httpService';
import { RouterService } from '../../services/routerService';
import { LoginModel } from '../../models/userModel'
// import { LoginModel } from '../../models/userModel'
const LOGIN_URL = "users/login";


@Component({
  selector: 'non-session-landing',
  templateUrl: './component.html',
  styleUrls: ['./component.scss']
})
export class NonSessionComponent implements AfterViewInit {
  // @ViewChild(Registration) public registrationModal: Registration;
  // @ViewChild(AdminPageComponent) public adminpageModal: AdminPageComponent;
  appSpinner: AppSpinner;
  tableData: any = {};
  @Input() applyisClicked: boolean = false;
  loginForm: LoginModel
  username: FormField = new FormField("", true, [Validations.EMPTY]);
  password: FormField = new FormField("", true, [Validations.EMPTY]);

  constructor(private contextService: ContextService, private httpService: HttpService, private routerService: RouterService) {
    this.appSpinner = this.contextService.getSpinnerContext();
    this.loginForm = new LoginModel();
    this.appSpinner.show("Loading...");

  }
  ngAfterViewInit() {
    this.applyisClicked = false
    setTimeout(() => {
      this.appSpinner.hide();
    }, 500);
  }

  adminShow() {
    this.routerService.showAdmissionPage();
    this.applyisClicked = true;
  }

  // openRegistration() {
  //   this.registrationModal.showModal(this);
  // }
  showdata() {
    // this.adminpageModal.showData();
    this.routerService.showAdmissionPage();
    this.applyisClicked = false;
  }
  checkTableData() {
    var data = this.tableData.data;
    debugger;
  }

  submitForm() {
    if (this.loginForm.username.validate() && this.loginForm.password.validate()) {
      this.doLogin();

    }
  }
  doLogin() {
    var appSpinner = this.contextService.getSpinnerContext();
    appSpinner.show("Logging In...");
    var formData = {
      "username": this.loginForm.username.value,
      "password": this.loginForm.password.value
    }
    this.httpService.post(LOGIN_URL, formData).subscribe(
      res => {
        if (typeof res.token !== "undefined") {
          this.contextService.logIn(res.token);
          // this.loginModal.hide();
          this.username.reset();
          this.password.reset();
          this.routerService.openStaffPage();
        } else {
          appSpinner.hide();
          this.password.reset();
          this.contextService.getAlertContext().showError("Internal Error. Unable To Login.<br>Please Contact System Administrator.");
        }
      },
      err => {
        appSpinner.hide();
        this.password.reset();
        this.contextService.getAlertContext().showError(err.errorText);
      }
    );
  }

  resetForm() {
    this.username.reset();
    this.password.reset();
  }
}
